module.exports = __webpack_public_path__ + "static/media/10_naga_tiger.fcbf0fdc.png";